import type { ExplicitAny, Nullish } from "~/@types/generics"
import type { TVariant } from "~/lib/shopify/serializers/serialize-variants"
import {
  COLOR_PARAM,
  OPTION_CONFORT,
  OPTION_SIZE,
  REMPLISSAGE_PARAM,
} from "~/components/ui/Product/ProductHeader/_data/constants"

function getComputedOptionName(optionName: string) {
  if (OPTION_SIZE.includes(optionName)) {
    return "size"
  }

  if (OPTION_CONFORT.includes(optionName)) {
    return "confort"
  }

  return null
}

export default function getVariantFromParams(variants: TVariant[], params: ExplicitAny): Nullish<TVariant> {
  if (!variants || !params) {
    return null
  }

  return variants.find((variant) => {
    if (!variant || !variant.selectedOptions) {
      return null
    }

    return variant.selectedOptions
      .filter(({ name }) => name?.toLowerCase() !== COLOR_PARAM && name?.toLowerCase() !== REMPLISSAGE_PARAM)
      .every((option) => {
        if (!option.name) {
          return null
        }

        const computedOptionName = getComputedOptionName(option.name)

        if (!computedOptionName) {
          return false
        }

        return params[computedOptionName] && params[computedOptionName] === option.value
      })
  })
}
